import { Link, useLocation } from 'react-router-dom';
import { BOOKING_URL } from '@/mocks/home';

interface Props { small?: boolean; label?: string; variant?: 'dark' | 'light' | 'outline' | 'text'; }

export default function BookButton({ small = false, label = 'Book Appointment', variant = 'dark' }: Props) {
  const { pathname } = useLocation();
  const external = BOOKING_URL.length > 0;
  const styles = {
    dark: 'border border-foreground-950 text-foreground-950 hover:bg-foreground-950 hover:text-background-50',
    light: 'bg-background-100 text-foreground-950 hover:bg-accent-200',
    outline: 'border border-foreground-950 text-foreground-950 hover:bg-foreground-950 hover:text-background-50',
    text: '',
  };
  const cls = variant === 'text'
    ? 'inline-flex items-center gap-2 text-[14px] font-medium text-foreground-950 border-b border-foreground-950 pb-0.5 whitespace-nowrap cursor-pointer hover:text-foreground-600'
    : `inline-flex items-center justify-center gap-3 rounded-full whitespace-nowrap cursor-pointer transition-colors duration-300 font-label font-medium ${small ? 'px-4 py-2 text-[13px]' : 'px-5 py-2.5 text-[14px]'} ${styles[variant]}`;
  const inner = (
    <>
      {label}
      <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
    </>
  );
  if (external) {
    return <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className={cls}>{inner}</a>;
  }
  if (pathname === '/visit') {
    return <a href="#book" data-route-fade className={cls}>{inner}</a>;
  }
  return <Link to="/visit#book" className={cls}>{inner}</Link>;
}